import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRootStore } from "@/myq-core";
export { default as mcdRoutes } from './mcd/routes';
export { default as thRoutes } from './th/routes';
export { default as standardRoutes } from './standard/routes';
import mcdRoutes from './mcd/routes';
import thRoutes from './th/routes';
import standardRoutes from './standard/routes';
import marketingRoutes from './marketingAgnency/routes';
import commsHubRoutes from './commsHub/routes'

export function getRoutes(enterprise) {
  if (!enterprise) {
    // try and find it in local storage
    const userString = localStorage.getItem('user');
    if (userString) {
      const userObj = JSON.parse(userString);
      enterprise = userObj?.user?.organization?.enterpriseClient;
    }
  }
  if (enterprise === 'CommsHub') {
    return commsHubRoutes;
  }

  if (enterprise === 'McDonalds') {
    return mcdRoutes;
  }
  if (enterprise === 'TimHortons') {
    return thRoutes;
  }
  if (enterprise === 'Popeyes') {
    return standardRoutes;
  }
  if (enterprise === 'MarketingAgency') {
    return marketingRoutes;
  }
  if (enterprise === 'DataPassRecipient') {
    return [
      {
        // this just boots them straight to /datapass/
        path: '/',
        alias: '/home-dashboard',
        name: 'DataPass',
        beforeEnter() {
          window.location.href = '/datapass/recipient/RequestOO';
        }
      }
    ];
  }
  return [];
}

export default function useRoutes() {
  const store = useRootStore();
  const { enterpriseClient } = storeToRefs(store);
  return computed(() => {
    return getRoutes(enterpriseClient.value);
  });
}